// extracted by mini-css-extract-plugin
module.exports = {"root":"spinner_root__SxQFI","rotation":"spinner_rotation__5xmGA"};